import { Variants } from 'framer-motion';

export const animationVariants: Variants = {
  visible: { opacity: 1, y: 0 },
  invisible: { opacity: 0, y: 20 },
};

export const animationVisible = 'visible';
export const animationInvisible = 'invisible';
